import { CARBON_NEUTRALS } from './carbon.preset';

/**
 * Categorical colours for Highcharts: the app's chart colours from before the Carbon theme, kept as
 * they were so the charts look the same. Every client without colours of its own uses them
 * (`clients.ts`). Assign slots in order.
 */
export const CARBON_CHART_COLORS: readonly string[] = [
    '#4baaf5', // light blue
    '#6ebe71', // green
    '#fccc55', // yellow
    '#ff6259', // red
    '#6372c3', // indigo
    '#f79530', // orange
    '#30aa9f', // teal
    '#30c9dc', // cyan
    '#af50bf', // purple
    '#7e96a1', // slate
];

/** Chart chrome on a white surface: text, axis and grid lines in the Carbon neutrals. */
export const CARBON_CHART_INK = {
    text: CARBON_NEUTRALS[600],
    muted: CARBON_NEUTRALS[500],
    axis: CARBON_NEUTRALS[300],
    grid: CARBON_NEUTRALS[200],
    surface: '#ffffff',
} as const;

/** Emissions avoided, wherever a chart sets them against emitted ones: one green for every client. */
export const CARBON_CHART_REDUCTION = '#46ad43';
